import { toastNotifications } from '@/services'

export default () => toastNotifications
